
    var riot = require('riot')
    
riot.tag2('riot-mail', '<a href="mailto:{mail.loc}@{mail.domain}"> <yield></yield></a>', '', '', function(opts) {
    const self = this
    self.mail = {
      loc: "alorb",
      domain: "tamaris.co.jp"
    }
});
    
  


// WEBPACK FOOTER //
// ./_src/riot/riot-mail.tag